import React from 'react';

import styles from './report_type_chip.module.css';

const TONE_BY_TYPE = {
  'Safety Concern': styles.safety,
  'Adherence Risk': styles.adherence,
  'Retention Risk': styles.retention,
};

export default function ReportTypeChip({ reportType }) {
  if (!reportType) {
    return null;
  }

  return <span className={`${styles.chip} ${TONE_BY_TYPE[reportType] || styles.neutral}`}>{reportType}</span>;
}
